import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getCourses = createAsyncThunk("course/getCourses", async () => {
  try {
    const response = await axios.get(`/GetUserCourses`);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getModules = createAsyncThunk("course/getModules", async (data) => {
  try {
    const response = await axios.post(`/GetUserCourseModules`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getCourseScore = createAsyncThunk("course/GetCourseScore", async (data) => {
  try {
    const response = await axios.post(`/GetCourseScore`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const joinSession = createAsyncThunk("course/joinSession", async (data) => {
  try {
    const response = await axios.post(`/JoinSession`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});


export const submitSessionFeedback = createAsyncThunk("course/submitSessionFeedback", async (data) => {
  try {
    const response = await axios.post(`/SubmitSessionFeedback`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});